// ** Third Party Components
import { parseCookies } from "nookies"
import { Navigate, Outlet, useLocation } from "react-router-dom"

// ** Variables
import { ACCESS_TOKEN } from "@pma/utils/constants"
import { LOGIN_PAGE_ROUTE } from "@pma/utils/page-routes"

const AuthGuard = () => {
  const location = useLocation()
  const isAuth = !!parseCookies()[ACCESS_TOKEN]

  return isAuth ? <Outlet /> : <Navigate to={LOGIN_PAGE_ROUTE} state={{ from: location }} replace />
}

export default AuthGuard
